export default "__VITE_ASSET__$IN5xB8R__"